module.exports = __webpack_public_path__ + "static/img/product2.88dff5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/black/product2.png
// module id = cBPI
// module chunks = 0